<br>
<br>
<div class="row">
  <div class="col-md-4">
  </div>
  <div class="col-md-4">
    <div class="card">
      <div class="card-header">Resend Email Confirmation Instructions</div>
      <div class="card-body">
       <form [formGroup]="resendEmailForm" (ngSubmit)="onSubmit(resendEmailForm)">
          <div class="form-group">
            <input type="email" name="email" class="form-control" placeholder="Email" formControlName="email">
          </div>
          <div class="form-group">
            <input type="submit" name="submit" class="btn btn-block btn-primary" value="Send me the instructions" [disabled]="!resendEmailForm.valid">
          </div>
        </form>
      </div>
      <div class="card-footer">
        <a routerLink="/login">Login</a> 
      </div>
    </div>
  </div>
</div>